import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter } from "react-router-dom";
import "@ocs/design-tokens/tokens.css";
import "./styles.css";
import { App } from "./App";

const queryClient = new QueryClient({
  defaultOptions: { queries: { staleTime: 3000, retry: 1 }, mutations: { retry: false } }
});

const rootElement = document.getElementById("root");
if (!rootElement) {
  throw new Error("Admin console root element is missing");
}
rootElement.dataset.app = "admin-console";

ReactDOM.createRoot(rootElement).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter><App /></BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>
);
